import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { useToast } from '../hooks/useToast'

export default function Categorias() {
  const [categorias, setCategorias] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editCat, setEditCat] = useState(null)
  const [nome, setNome] = useState('')
  const [saving, setSaving] = useState(false)
  const { msg, visible, show } = useToast()

  useEffect(() => { fetchCategorias() }, [])

  async function fetchCategorias() {
    setLoading(true)
    const { data } = await supabase.from('categorias').select('*').order('nome')
    setCategorias(data || [])
    setLoading(false)
  }

  function openForm(cat = null) {
    setEditCat(cat)
    setNome(cat ? cat.nome : '')
    setShowForm(true)
  }

  async function salvar() {
    if (!nome.trim()) { show('Digite o nome da categoria'); return }
    setSaving(true)
    if (editCat) {
      await supabase.from('categorias').update({ nome: nome.trim() }).eq('id', editCat.id)
      show('✅ Categoria atualizada!')
    } else {
      await supabase.from('categorias').insert([{ nome: nome.trim() }])
      show('✅ Categoria cadastrada!')
    }
    setSaving(false)
    setShowForm(false)
    fetchCategorias()
  }

  async function deletar(cat) {
    if (!window.confirm(`Remover "${cat.nome}"?`)) return
    const { count } = await supabase.from('itens').select('*', { count: 'exact', head: true }).eq('categoria', cat.nome)
    if (count > 0) {
      show(`"${cat.nome}" está em uso em ${count} item(s) — altere-os primeiro`)
      return
    }
    const { error } = await supabase.from('categorias').delete().eq('id', cat.id)
    if (error) {
      show('Erro ao remover categoria')
    } else {
      show('Categoria removida')
      fetchCategorias()
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 className="page-title" style={{ margin: 0 }}>Categorias</h1>
        <button className="btn btn-primary btn-sm" onClick={() => openForm()}>+ Nova</button>
      </div>

      {loading && <div className="spinner">Carregando...</div>}

      {!loading && categorias.length === 0 && (
        <div className="empty">
          <div className="empty-icon">🏷️</div>
          <p>Nenhuma categoria ainda.</p>
          <br />
          <button className="btn btn-ghost btn-sm" onClick={() => openForm()}>Criar primeira categoria</button>
        </div>
      )}

      {!loading && categorias.length > 0 && (
        <div className="card" style={{ padding: '4px 16px' }}>
          {categorias.map(cat => (
            <div key={cat.id} className="list-item">
              <div className="item-name">{cat.nome}</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-ghost btn-sm" onClick={() => openForm(cat)}>editar</button>
                <button className="btn btn-danger btn-sm" onClick={() => deletar(cat)}>remover</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal">
            <div className="modal-handle" />
            <div className="modal-title">{editCat ? 'Editar categoria' : 'Nova categoria'}</div>
            <div className="field">
              <label>Nome</label>
              <input
                placeholder="Ex: Flor, Folhagem, Embalagem..."
                value={nome}
                onChange={e => setNome(e.target.value)}
                autoFocus
              />
            </div>
            <button className="btn btn-primary" onClick={salvar} disabled={saving}>
              {saving ? 'Salvando...' : editCat ? 'Salvar alterações' : 'Cadastrar'}
            </button>
          </div>
        </div>
      )}

      <div className={`toast ${visible ? 'show' : ''}`}>{msg}</div>
    </div>
  )
}
